import { useTimeoutEffect } from "@react-hookz/web";
import React, { useState } from "react";
import { FollowButtonAction, FollowButtonDisplay, FollowButtonOutline, FollowButtonSize, FollowButtonVariant } from "./enums";
import { BluePlusFollowingIconContainer, BluePlusFollowingText, StyledBluePlusIcon, StyledBlueSpinningLoadingIcon, StyledBlueSquareFollowIcon, StyledButton, StyledGrayCircleBlackTickFollowingIcon, StyledGrayCircleFollowIcon, StyledGrayCircleWhiteTickFollowingIcon } from "./styles";
export const FollowButton = ({
  className,
  disabled,
  display = FollowButtonDisplay.Text,
  isFollowing,
  isLoadingEnabled = false,
  loadingDelay = 1500,
  onClick,
  outline = FollowButtonOutline.Filled,
  size = FollowButtonSize.Normal,
  variant = FollowButtonVariant.Light
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleFollowAction = () => {
    onClick(isFollowing ? FollowButtonAction.Unfollow : FollowButtonAction.Follow);
  };
  useTimeoutEffect(() => {
    setIsLoading(false);
  }, isLoading ? loadingDelay : undefined);
  const handleClick = () => {
    handleFollowAction();
    if (isLoadingEnabled) {
      setIsLoading(true);
    }
  };
  const renderDisplay = () => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(StyledBlueSpinningLoadingIcon, null);
    }
    const followingIcon = variant === FollowButtonVariant.Homepage ? /*#__PURE__*/React.createElement(StyledGrayCircleBlackTickFollowingIcon, null) : /*#__PURE__*/React.createElement(StyledGrayCircleWhiteTickFollowingIcon, null);
    switch (display) {
      case FollowButtonDisplay.BluePlusIcon:
        return isFollowing ? "FOLLOWING" : /*#__PURE__*/React.createElement(BluePlusFollowingIconContainer, null, /*#__PURE__*/React.createElement(StyledBluePlusIcon, null), /*#__PURE__*/React.createElement(BluePlusFollowingText, null, "FOLLOW"));
      case FollowButtonDisplay.Text:
        return isFollowing ? "FOLLOWING" : "+ FOLLOW";
      case FollowButtonDisplay.BlueSquareIcon:
        return isFollowing ? followingIcon : /*#__PURE__*/React.createElement(StyledBlueSquareFollowIcon, null);
      case FollowButtonDisplay.CircleGrayIcon:
        return isFollowing ? followingIcon : /*#__PURE__*/React.createElement(StyledGrayCircleFollowIcon, null);
    }
  };
  return /*#__PURE__*/React.createElement(StyledButton, {
    className: className,
    disabled: disabled,
    isFollowing: isFollowing,
    isLoading: isLoading,
    outline: outline,
    size: size,
    variant: variant,
    onClick: handleClick,
    "data-qa": "follow-button"
  }, renderDisplay());
};
export { StyledBlueSpinningLoadingIcon } from "./styles";